export enum DashboardModules {
  DASHBOARD = "Dashboard",
  DASHBOARD_DETAILS = "Dashboard Detail",
  FLOOR_PLAN_DETAILS = "Floor Plan Detail",
}

export enum AssetModules {
  ASSET = "Asset",
  ASSET_DETAILS = "Asset Details",
  LIGHT_PARAMETERS = "Light Parameters",
  LIGHT_PARAMETER = "Light Parameter",
  SENSOR_PARAMETER = "Sensor Parameter",
  TRIGGERING_ZONE = "Triggering Zone",
  LIGHT_SCHEME = "Light Scheme",
  LIGHT_PROFILE = "Light Profile",
  DISABLE_PREDICTIVE_LIGHTING = "Disable Predictive Lighting",
  SENSOR_PARAMETERS = "Sensor Parameters",
  TIMER_PROFILE = "Timer Profile",
  DIMMING_PROFILE = "Dimming Profile",
  LUMINANCE_PROFILE = "Luminance Profile",
  DAYLIGHT_PROFILE = "DayLight Profile",
  RAIN_PROFILE = "Rain Profile",
  DAYLIGHT_HARVESTING = "DayLight Harvesting",
}

export enum FaultModules {
  FAULT = "Fault",
}

export enum TestModules {
  TEST = "Test",
}

export enum ReportModules {
  REPORT = "Report",
  FAULT_REPORT = "Fault Report",
  BURN_TIME_REPORT = "Burn Time Report",
  MOTION_TRAFFIC_REPORT = "Motion Traffic Report",
  MOTION_HEAT_MAP_REPORT = "Motion Heat Map Report",
  ENERGY_REPORT = "Energy Report",
  TEST_REPORT = "Test Report",
  USER_ACTIVITY_REPORT = "User Activity Report",
  ENVIRONMENTAL_REPORT = "Environmental Report",
}

export enum AdminModules {
  ADMIN = "Admin",
  USER = "User",
  USERS = "Users",
  PENDING_APPROVAL = "Pending Approval",
  ROLE = "Role",
  ACCESS_MAPPING = "Access Mapping",
  SMART_LIGHT_SUPPLIER = "Smart Light Supplier",
  SUPPLIER_LIST = "Supplier List",
  LOCATION = "Location",
  TOWN_COUNCIL = "Town Council",
  BLOCK = "Block",
  Location = "Location",
  SITE = "Site",
  INVENTORY = "Inventory",
  ASSET_MODEL = "Asset Model",
  DRIVER_MODEL = "Driver Model",
  ASSET = "Asset",
  DEVICE_MANAGEMENT_SYSTEM = "Device Management System",
  DASHBOARD = "Dashboard",
  DEVICE = "Device",
  CERTIFICATE = "Certificate",
  OTA = "OTA",
  CONFIGURATION = "Configuration",
  REPORT_CONFIGURATION = "Report Configuration",
  BASELINE = "Baseline",
  ALERT_CONFIGURATION = "Alert Configuration",
  MASTER_CONFIGURATION = "Master Configuration",
  SIM_CARD = "SIM Card",
}

export enum UserModules {
  USER = "User",
  PROFILE = "Profile",
  NOTIFICATION = "Notification",
}

export const ROOT_MODULE_ACTION = "Root-Module-Action";
